// @flow @format
import {connect} from 'react-redux';
import DownloadProgress from '../components/DownloadProgress';
import {
	startDownload,
	pauseDownload,
} from '../../../reducers/entities/downloads';
import {toggleHistory} from '../../../reducers/history';
import {
	DOWNLOAD_RUNNING_STATUS,
	DOWNLOAD_RETRY_STATUS,
	DOWNLOAD_SETUP_STATUS,
	DOWNLOAD_PAUSING_STATUS,
	DOWNLOAD_PAUSED_STATUS,
} from 'lib/downloader';

import type {State} from '../../../reducers';
import type {DownloadSummary} from 'lib/downloader';

const mapStateToProps = (state: State) => {
	const running: DownloadSummary[] = [];
	const pausing: DownloadSummary[] = [];
	const paused: DownloadSummary[] = [];

	for (const id of Object.keys(state.entities.downloads.entities)) {
		const download = state.entities.downloads.entities[id];

		switch (download.status) {
			case DOWNLOAD_SETUP_STATUS:
			case DOWNLOAD_RETRY_STATUS:
			case DOWNLOAD_RUNNING_STATUS:
				running.push(download);
				break;
			case DOWNLOAD_PAUSING_STATUS:
				pausing.push(download);
				break;
			case DOWNLOAD_PAUSED_STATUS:
				paused.push(download);
				break;
			default:
				break;
		}
	}

	if (running.length > 0) {
		return {
			download: running[0],
			throughput: state.entities.downloads.throughput,
		};
	}

	if (pausing.length > 0) {
		return {
			download: pausing[0],
			throughput: state.entities.downloads.throughput,
		};
	}

	if (paused.length > 0) {
		const sorted = paused.sort((lhs, rhs) => rhs.updatedAt - lhs.updatedAt);
		return {
			download: sorted[0],
			throughput: state.entities.downloads.throughput,
		};
	}

	return {download: null, throughput: state.entities.downloads.throughput};
};

const mapDispatchToProps = {
	toggleHistory,
	startDownload,
	pauseDownload,
};

export default connect(mapStateToProps, mapDispatchToProps)(DownloadProgress);



// WEBPACK FOOTER //
// ./src/routes/Explorer/containers/DownloadProgressContainer.js